import * as React from "react";
import { forwardRef } from "react";
const SvgSignalMedium = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-signal-medium-icon lucide-signal-medium", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 20h.01" }), /* @__PURE__ */ React.createElement("path", { d: "M7 20v-4" }), /* @__PURE__ */ React.createElement("path", { d: "M12 20v-8" }));
const ForwardRef = forwardRef(SvgSignalMedium);
export default ForwardRef;
